import React from 'react'
import { cn } from '@/lib/utils'

interface DrawerFooterProps {
  children: React.ReactNode
  className?: string
  align?: 'left' | 'center' | 'right' | 'between'
}

export function DrawerFooter({ 
  children, 
  className,
  align = 'right' 
}: DrawerFooterProps) {
  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
    between: 'justify-between',
  }

  return (
    <div className={cn(
      "flex items-center gap-3 px-6 py-4 border-t border-border",
      "bg-card",
      alignmentClasses[align],
      className
    )}>
      {children}
    </div>
  )
}